<template>
  <v-dialog v-model="dialog" max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn class="ma-3" dark small color="primary" name="Add" v-on="on"
        >ADD</v-btn
      >
    </template>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="_onYes"
      v-click-outside="close_dialog"
    >
      <v-card>
        <v-card-title class="ma-2">Add {{ data }}</v-card-title>
        <v-divider class="ma-2"></v-divider>
        <v-card-text
          v-if="data.includes('Company')"
          class="ma-2"
          style="width: auto"
        >
        <v-col cols="12">
            <v-text-field
              v-model="local_data_username"
              :rules="rules.nameRules"
              label="Name"
              required
              autofocus
            ></v-text-field>
          </v-col>
          <v-col cols="11">
            <v-textarea
              v-model="local_data_description"
              width="80%"
              name="input-7-4"
              label="Description"
            ></v-textarea>
          </v-col>
        </v-card-text>
        <v-card-text
          v-else-if="data.includes('User')"
          class="ma-2"
          style="width: auto"
        >
          <v-row v-if="data.includes('Customer')">
            <v-col>
              <v-checkbox
                v-model="local_data_sftp"
                :label="`Enable to create sftp user`"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="local_data_email"
                :rules="rules.emailRules"
                label="E-mail"
                required
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                v-model="local_data_firstname"
                :rules="rules.nameRules"
                :counter="20"
                label="First Name"
                required
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="local_data_lastname"
                :rules="rules.nameRules"
                :counter="20"
                label="Last Name"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row style="display: initial">
            <v-col>
              <VuePhoneNumberInput v-model="user.phone" :preferredCountries="['GB', 'IT', 'FR']" :countries-height="15" color="#FF0000" @update="updateNumber($event)" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="ma-2 text-right">
          <v-btn color="white" name="Cancel" class="text-right" @click="_onNo()"
            >CANCEL</v-btn
          >
          <v-btn color="primary" name="Add" class="text-right" type="submit"
            >ADD</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  data: () => ({
    dialog: false,
    valid: true,
    local_data_sftp: "",
    local_data_username: "",
    local_data_firstname: "",
    local_data_lastname: "",
    local_data_email: "",
    local_data_phone: "",
    local_data_description: "",
    user: {
      sftp: false,
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      description: ""
    },
    roles: ["Administrator", "Operator", "Provider", "Customer"],
    rules: {
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) =>
          /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/g.test(
            v
          ) || "please set a valid phone number",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 50 characters",
        (v) =>
          /[+=,.@_-\w]$/g.test(v) ||
          "please set a valid Name [allowed characters are: + = , . @ _ - ]",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(v) ||
          "E-mail must be valid",
      ],
    },
  }),
  props: ["data"],
  computed: {
    ...mapState({
      organizations: (state) => state.organizations,
    }),
  },
  components: {
    VuePhoneNumberInput
  },
  created() {
    if (this.$refs.form) {
      this.$refs.form.reset();
      this.user.phone = "";
    }
  },
  methods: {
    _onYes() {
      this.user.sftp = this.local_data_sftp;
      this.user.username = this.local_data_username;
      this.user.firstname = this.local_data_firstname;
      this.user.lastname = this.local_data_lastname;
      this.user.email = this.local_data_email;
      this.user.phone = this.local_data_phone;
      this.user.description = this.local_data_description;
      if (this.data.includes('User')) {
        if (this.$refs.form.validate() && /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/g.test(this.user.phone)) {
          this.$emit("add", this.user);
          this.$refs.form.reset();
          this.dialog = false;
        }
        if (/^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/g.test(this.user.phone) === false) {
          this.$store.dispatch("dispatchError", {
            text: "please set a valid phone number",
            type: "danger",
          });
          this.user.phone = "";
        }
      } else {
        if (!this.user.username){
          this.$store.dispatch("dispatchError", {
            text: "please set a valid name",
            type: "danger",
          });
        } else {
          this.$emit("add", { username: this.user.username, description: this.user.description})
        }
      }
      this.$refs.form.reset();
      this.dialog = false;
    },
    _onNo() {
      this.$refs.form.reset();
      this.user.phone = "";
      this.dialog = false;
    },
    close_dialog() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.user.phone = "";
      }
    },
    updateNumber(model) {
      this.local_data_phone = model.formatInternational
    }
  },
};
</script>